import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthRouteHandler } from './components/Auth'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthRouteHandler>
      <App />
    </AuthRouteHandler>
  </React.StrictMode>,
)
